<template>
  <div class="expense-entry-page">
    <div class="expense-entry-heading">
      <div class="expense-entry-heading__icon" aria-hidden="true"><i class="fas fa-receipt"></i></div>
      <div>
        <span>Keuangan klinik</span>
        <h1>Tambah pengeluaran</h1>
        <p>Catat transaksi operasional dengan informasi yang lengkap dan terstruktur.</p>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <Card :card-class="'expense-entry-card'">
          <template v-slot:body>
            <Form :form="form" route="expenses" type="add"/>
          </template>
        </Card>
      </div>
    </div>

  </div>
</template>

<script>

import Card from '@/view/content/Card.vue'
import Form from '@/component/expenses/Form.vue'
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module"

export default {

  components: {
    Card,
    Form
  },

  data() {
    return {
      // Form
      form: {
        date: '',
        name: '',
        amount: '',
        flow_type: '1',
        expense_method: '1',
        expense_method_type: '1',
        expense_category_id: '',
        notes: '',
        photo: [],
        photo_name: "/images/default-expense.svg"
      },
    }
  },

  mounted() {
    // BreadCrumb
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Keuangan" },
      { title: "Tambah Pengeluaran" },
    ])
  },

}
</script>

<style lang="scss" src="@/assets/sass/pages/_expense-entry-page.scss"></style>
